<div class="flex flex-col flex-1 p-3 justify-between">
    <div class="h-full w-full pt-[3.75rem] p-5 flex justify-center items-start">
        <div class="flex flex-col items-center justify-center gap-2 w-[20rem] max-w-full">
            @if(isLoading) {
                <div class="flex flex-col justify-between items-center gap-4 pt-[6.2rem]">
                    <app-spinner-loader [inline]="true" size="lg"></app-spinner-loader>
                </div>
            } @else if(chatBotStyles.tenantCode){
                <div class="flex flex-col justify-between items-center gap-2 pt-2">
                    <img
                        *ngIf="chatBotStyles.companyLogo"
                        [src]="chatBotStyles.companyLogo"
                        alt="company logo"
                        class="h-[4.6706rem] w-[4.6706rem] object-contain" 
                    />
                    <div class="text-lg font-semibold text-[var(--colorDefault)] font-['Open_Sans'] text-center w-[18.25rem]">Hello! I’m your AI-powered Service Assistant, here to help you with your service needs.</div>
                </div>
            
                <div class="flex flex-col justify-between items-center gap-8 py-6 px-4 w-[20rem]">
                    <div class="flex flex-col pb-4 items-center gap-2 w-full">
                        <div class="text-base font-normal text-[var(--colorDefault)] font-['Open_Sans'] text-center w-full">
                            May I have your name?
                        </div>
                        <input type="text" class="focus:outline-none focus:ring-0 w-full h-10 border border-[var(--colorDefault)]/30 text-[var(--colorDefault)] placeholder:text-[var(--colorDefault)]/60 rounded-md px-3 text-xs text-center font-normal" 
                            placeholder="Enter your name" 
                            [(ngModel)]="customerName"
                            (keydown)="handleKeyDownEnter($event)"/>
                    </div>
                    <button
                        type="button"
                        class="w-full flex justify-center gap-[0.625rem] items-center h-10 bg-[var(--primaryColor)] text-[var(--secondaryTextColor)] rounded-lg text-sm font-semibold"
                        (click)="startChat()" 
                        [disabled]="!customerName.trim()"
                        [ngClass]="{'opacity-50':!customerName.trim()}"
                    >
                    <img
                        *ngIf="chatBotStyles.startChatBtnIcon"
                        [src]="chatBotStyles.startChatBtnIcon"
                        alt="startChatBtnIcon"
                        class="h-5 w-5 object-contain" 
                    />
                        Start Chat
                    </button>        
                </div>
            } @else {
                <div class="flex flex-col justify-between items-center gap-4 pt-[4.2rem]">
                    <img
                        [src]="getBaseAssetUrl('assets/images/service_alert.svg')"
                        alt="service_alert"
                        class="h-[18.6706rem] w-[18.6706rem] object-contain" 
                    />
                    <div class="text-xl font-medium text-[var(--colorDefault)] font-['Open_Sans'] w-[17.25rem] text-center">Oops! The service is currently unavailable.</div>
                </div>
            }
        </div>
    </div>
    <div class="flex flex-col items-center justify-center h-5 w-full">
      <p class="text-xs text-gray-500">
        Powered by <a href="https://www.titandms.com/" target="_blank" class="text-[var(--botIconColor)]">TitanDMS</a>
      </p>
    </div>
</div>
